import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=9352143c&scoped=true"
import script from "./confirmDialog.vue?vue&type=script&lang=js"
export * from "./confirmDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=9352143c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9352143c",
  null
  
)

export default component.exports